/**
 * @generated SignedSource<<f8315a29bd5c7e5a2f590bc33608bf78>>
 * @relayHash 03d0b36dbfc0f84b81e3ca48e36a6e7b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 04c1fba8df45d251a0f00e03bda2406c57347ce5fb839d27446ae6d7d61b8c00

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type FilterRefetchQuery$variables = {
  filterAri: string;
  includeFilter: boolean;
};
export type FilterRefetchQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_IssueNavigator_filterQuery">;
};
export type FilterRefetchQuery = {
  response: FilterRefetchQuery$data;
  variables: FilterRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filterAri"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "includeFilter"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "FilterRefetchQuery",
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "main_issueNavigator_IssueNavigator_filterQuery"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FilterRefetchQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "condition": "includeFilter",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": [
                  {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "filterAri"
                  }
                ],
                "kind": "LinkedField",
                "name": "filter",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isJiraFilter"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "jql"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "isEditable"
                      }
                    ],
                    "type": "JiraCustomFilter"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "filterId"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "name"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "isFavourite"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "id"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "04c1fba8df45d251a0f00e03bda2406c57347ce5fb839d27446ae6d7d61b8c00",
    "metadata": {},
    "name": "FilterRefetchQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "96adaeb0ea412a121f8c6bd7c6d18060";

export default node;
